app.controller('EmployeeNewDocumentController', ['$scope', '$uibModal', '$stateParams', 'AuthService', 'StaticData', 'DocumentsService', '$http', 'usSpinnerService', 'toastr', '$state', '$rootScope', 'Hr',
    function ($scope, $uibModal, $stateParams, AuthService, StaticData, DocumentsService, $http, usSpinnerService, toastr, $state, $rootScope, Hr) {
        $scope.documentId = $stateParams.documentId;
        $scope.isRoot = false;
        $scope.hasSpecialResolutionRight = false;
        $scope.format = "dd-MM-yyyy";
        $scope.documentTypes = {
            'INNER': [],
            'STUDENT_INNER': [],
            'OUTER': [],
            'OUTGOING': [],
            'OTHER': []
        };
        $scope.type = null;
        $scope.documentAddressees = {
            'UNIT': [],
            'PERSON': []
        };
        $scope.addresseeType = null;
        $scope.text = '';
        $scope.comment = '';
        $scope.resolutionComment = '';
        $scope.addressees = [];
        $scope.addressee = null;
        $scope.attachments = [];
        $scope.infos = [];
        $scope.currentInfo = null;
        $scope.author = null;
        $scope.pickerPopup = { opened: false };
        $scope.action = $stateParams.action || 'create';
        $scope.isForStudent = null;
        $scope.basisFileNumber = null;
        $scope.basisFile = null;
        $scope.basisFiles = $stateParams.basis ? [{ 'uniqueNumber': $stateParams.basis, '_id': $stateParams.documentId }] : [];
        $scope.deadLine = null;
        $scope.currentEmployeeProfile = null;
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            minDate: new Date(),
            startingDay: 1
        };
        $scope.popup1 = {
            opened: false
        };
        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };
        $scope.isTemplateForDepartment = $stateParams.department === '1';
        $scope.preparedForOrganization = null;

        AuthService.getUserData().then(function (user) {
            // TODO გასარკვევია რისთვის არის საჭირო $scope.profile....
            $scope.profile = user.profiles.filter(function (p) {
                return p.type === "employee" && p.state === 'active'
            })[0];
            $scope.currentEmployeeProfile = user.employee.profile;
            if ($scope.profile) {
                var specialPositions = [
                    'კანცლერი',
                    'რექტორი',
                    'დამფუძნებლის სრულუფლებიანი წარმომადგენელი'
                ];
                if (specialPositions.indexOf($scope.profile.employee.position) > -1) {
                    $scope.hasSpecialResolutionRight = true;
                }
            }

            AuthService.isRoot = $scope.profile.employee ? $scope.profile.employee.isRoot : $scope.profile.positionInfo.isRoot;
            $scope.isRoot = AuthService.isRoot;
        });

        if ($stateParams.documentId && !$stateParams.basis) {
            usSpinnerService.spin('root');
            DocumentsService.fetchOne($stateParams.documentId).then(function (doc) {
                $scope.isForStudent = doc.isForStudent;
                $scope.infos = doc.infos;
                $scope.currentInfo = $scope.infos.find(function (info) {
                    return info.addressee._id === ($scope.currentEmployeeProfile || $scope.profile._id) && ['read', 'unread'].indexOf(info.status) > -1
                });
                $scope.author = doc.author;
                $scope.type = doc.type ? doc.type._id : null;
                $scope.text = doc.text;
                $scope.comment = doc.comment;
                $scope.attachments = doc.attachments;
                $scope.basisDocs = doc.basisDocs;
                $scope.basisFiles = doc.basisFiles;
                if (doc.deadline) {
                    $scope.dateOptions.maxDate = new Date(doc.deadline);
                }
                if ($stateParams.action != 'resolve') $scope.addressees = doc.addressees || [];
                usSpinnerService.stop('root');
            });
        }

        DocumentsService.typeList({ admin: $stateParams.documentId ? true : false }).then(function (data) {
            data.forEach(function (type) {
                $scope.documentTypes[type.parentId].push(type)
            });

        }).catch(function (err) {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        DocumentsService.getDocumentAddressee({isResolution: $scope.action == 'resolve'}).then(function (data) {
            data.forEach(function (addressee) {
                if (addressee.isUnit)
                    $scope.documentAddressees['UNIT'].push(addressee);
                else
                    $scope.documentAddressees['PERSON'].push(addressee);

            });

        }).catch(function (err) {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.addToBasis = function () {


            if (!$scope.basisFiles.find(a => a._id == $scope.basisFileNumber._id)) {
                $scope.basisFiles.push($scope.basisFileNumber);
            }

            $scope.basisFileNumber = null;
        };

        $scope.deleteAddressee = function (id) {
            var el_index = _.findIndex($scope.addressees, function (addr) {
                return id === addr._id;
            });

            $scope.addressees.splice(el_index, 1);
        };

        $scope.getDocumentNumbers = function (query) {
            if (query.length < 1) {
                return [];
            }
            return DocumentsService.getDocumentNumbers({
                uniqueNumber: query
            }).then(function (data) {
                return data;
            });
        };

        $scope.send = function () {
            if (!$scope.type) toastr.error('', 'გთხოვთ მიუთითოთ დოკუმენტის ტიპი');
            else if (!$scope.addressees.length && !$scope.addresseeType) toastr.error('', 'გთხოვთ მიუთითოთ ადრესატი');
            else if (!$scope.text) toastr.error('', 'გთხოვთ შეავსოთ ტექსტი');
            // else if ($scope.attachmentRequired() && $scope.attachments.length === 0) {
            //     toastr.error('', 'გთხოვთ, მიაბათ ფაილი');
            // }
            else {
                usSpinnerService.spin("root");
                if ($scope.basisFiles) {
                    var basisDocs = [];
                    var basisFiles = [];
                    for (var i in $scope.basisFiles) {
                        if ($scope.basisFiles[i].location) basisFiles.push($scope.basisFiles[i]._id)
                        else basisDocs.push($scope.basisFiles[i].uniqueNumber)
                    }
                }
                DocumentsService.send({
                    baseDraftDocument: $scope.documentId,
                    type: $scope.type,
                    text: $scope.text,
                    comment: $scope.comment,
                    addressees: $scope.addressees.map(function (item) {
                        var addressee = null;
                        if (item.isUnit) {
                            addressee = item;
                            addressee.info = { _id: item._id };
                        } else {
                            addressee = _.omit(item, 'profile');
                            addressee.info = { _id: item.profile._id };
                        }

                        return addressee;
                    }),
                    addresseeType: $scope.addresseeType,
                    attachments: $scope.attachments,
                    basisFiles: basisFiles,
                    basisDocs: basisDocs,
                    deadline: $scope.deadLine
                }).then(function (res) {
                    usSpinnerService.spin("root");
                    toastr.success('', 'დოკუმენტი გაგზავნილია');
                    $rootScope.documentsCount();
                    if($stateParams.returnUrl) {
                        history.replaceState(null, null, $stateParams.returnUrl)
                    } else {
                        $state.go('employee.documents.sent')
                    }
                }).catch(function (err) {
                    usSpinnerService.spin("root");
                    toastr.error('', 'დოკუმენტის გაგზავნისას დაფიქსირდა შეცდომა');
                })
            }
        };

        $scope.resolve = function () {
            if (!$scope.addressees.length && !$scope.addresseeType) {
                toastr.error('', 'გთხოვთ მიუთითოთ ადრესატი');
            } else {
                var enableResolution = true;
                for (var i in $scope.addressees) {
                    var addresseID = $scope.addressees[i].isUnit ? $scope.addressees[i].profile._id : $scope.addressees[i]._id;
                    for (var k in $scope.infos) {
                        if (addresseID == $scope.infos[k].addressee._id && ['read', 'unread'].indexOf($scope.infos[k].status) > -1) {
                            toastr.error('', 'თანამშრომელი უკვე დამატებულია დოკუმენტის ადრესატთა სიაში');
                            enableResolution = false;
                            return;
                        }
                        // else if (addresseID == $scope.author._id) {
                        //     toastr.error('', 'დოკუმენტის ავტორზე რეზოლუცია არ არის შესაძლებელი');
                        //     enableResolution = false;
                        //     return;
                        // }
                    }
                }
                var key = 'resolve';
                // იგივე რეზოლუციია გახდა სტუდენტის შემთხვევაშიც... თუ საჭირო აღარ იქნება წავშალოთ...!!!
                // if ($scope.isForStudent) key = 'resolveStudentsDoc';
                if (enableResolution) {
                    DocumentsService[key]({
                        documentInfo: $scope.currentInfo ? $scope.currentInfo._id : null,
                        documentId: $stateParams.documentId,
                        resolutionComment: $scope.resolutionComment,
                        deadline: $scope.deadLine,
                        addressees: $scope.addressees.map(function (item) {
                            var addressee = {};
                            if (item.isUnit) {
                                addressee.info = { _id: item.profile._id };
                            } else {
                                addressee = _.omit(item, 'profile');
                                addressee.info = { _id: item.profile._id };
                            }

                            return addressee;
                        })
                    }).then(function (res) {
                        usSpinnerService.spin("root");
                        toastr.success('', 'დოკუმენტი გადაგზავნილია');
                        $rootScope.documentsCount();
                        if($stateParams.returnUrl) {
                            history.replaceState(null, null, $stateParams.returnUrl)
                        } else {
                            $state.go('employee.documents.incoming', {state: 'unread'})
                        }
                    }).catch(function (err) {
                        usSpinnerService.spin("root");
                        let errorText = '';
                        if(err.data === 'Addressee Already Exists') {
                            errorText = ' - ადრესატი უკვე დამატებულია';
                        }
                        toastr.error('', 'დოკუმენტის გადაგზავნისას დაფიქსირდა შეცდომა' + errorText);
                    })
                }
            }
        };

        $scope.saveAsDraft = function () {
            var basisDocs = [];
            var basisFiles = [];
            if ($scope.basisFiles) {
                for (var i in $scope.basisFiles) {
                    if ($scope.basisFiles[i].location) basisFiles.push($scope.basisFiles[i]._id)
                    else basisDocs.push($scope.basisFiles[i].uniqueNumber)
                }
            }

            DocumentsService.send({
                _id: $stateParams.documentId,
                type: $scope.type,
                text: $scope.text,
                comment: $scope.comment,
                status: 'draft',
                isTemplateForDepartment: $scope.isTemplateForDepartment,
                preparedForOrganization: $scope.preparedForOrganization ? $scope.preparedForOrganization._id : null,
                action: $scope.action,
                addressees: $scope.addressees,
                attachments: $scope.attachments,
                basisFiles: basisFiles,
                basisDocs: basisDocs,
            }).then(function (res) {
                toastr.success('', 'მონახაზი შენახულია');
                $rootScope.documentsCount();
                $state.go('employee.documents.draft')
            }).catch(function (err) {
                toastr.error('', 'მონახაზის შენახვისას დაფიქსირდა შეცდომა');
            })
        };

        $scope.uploadAttachment = function (type, files) {
            usSpinnerService.spin("root");
            $scope.file = files[0];
            var fd = new FormData();
            if ($scope.file && $scope.file.name) {
                fd.append('file', $scope.file, $scope.file.name);
                $http.post('/documents/attachments', fd, {
                    headers: { 'Content-Type': undefined }
                }).then(function (response) {
                    if (type === 'basis') {
                        $scope.basisFiles.push(response.data);
                        $scope.fileName = response.data.name;
                    } else if (type === 'attachment') {
                        $scope.attachments.push(response.data);
                        $scope.fileName = response.data.name;
                    }
                    usSpinnerService.stop("root");
                })
            }
        };

        $scope.removeAttachment = function (type, file) {
            usSpinnerService.spin("root");
            if (type === 'basis' && !file.location) {
                for (var i in $scope.basisFiles) {
                    if (!$scope.basisFiles[i].location && file.name === $scope.basisFiles[i].name) {
                        $scope.basisFiles.splice(i, 1);
                        usSpinnerService.stop("root");
                    }
                }
            } else if (file.location) {
                DocumentsService.removeAttachment(file._id).then(function (res) {
                    var elementIndex;
                    if (type === 'basis') {
                        elementIndex = _.findIndex($scope.basisFiles, function (basisFile) {
                            return basisFile._id === file._id;
                        });
                        $scope.basisFiles.splice(elementIndex, 1);
                    }
                    if (type === 'attachment') {
                        elementIndex = _.findIndex($scope.attachments, function (attachmentFile) {
                            return attachmentFile._id === file._id;
                        });
                        $scope.attachments.splice(elementIndex, 1);
                    }
                    usSpinnerService.stop("root");
                })
            } else {
                usSpinnerService.stop("root");
            }
        };

        $scope.setAddresseeAsVisior = function (addressee) {
            $scope.addressees = $scope.addressees.map(function (a) {
                if (addressee.profile._id === a.profile._id) {
                    a.type = addressee.visior ? 'visa' : null
                }
                return a;
            })
            $scope.addressees = _.sortBy($scope.addressees, 'type');
        };

        $scope.addToAddresseeList = function () {
            // თუ ადრესატი ხელით მოიძებნა || თუ დაგენერირებული ხიდან აირჩა
            if ($scope.addressee && ($scope.addressee.profile || $scope.addressee.user)) {
                var addressee = $scope.addressee;
                if(!$scope.addressee.profile) {
                    addressee.profile = $scope.addressee;
                }
                if ($scope.hasSpecialResolutionRight) {
                    addressee = {
                        isUnit: false,
                        name: addressee.profile.user.firstName + ' ' + addressee.profile.user.lastName,
                        profile: {
                            positionInfo: addressee.positionInfo ? addressee.positionInfo : addressee.profile,
                            _id: addressee.profile._id
                        },
                    };
                }
                var existing = $scope.addressees.filter(function (a) {
                    return a.profile._id === addressee.profile._id;
                });
                if (existing.length > 0) {
                    toastr.error('', 'ადრესატი უკვე დამატებულია');
                } else {
                    usSpinnerService.spin("root");
                    Hr.getCurrentVacation(addressee.profile._id).then(function (res) {
                        if (res.vacation) {
                            //todo check vacation
                            addressee.vacation = res.vacation;
                            addressee.performer = res.performer;
                        }
                        $scope.addressees.push(addressee);
                        usSpinnerService.stop("root");
                    });
                }
                $scope.addressee = null;
            }
        };

        $scope.getEmployees = function (query) {
            if (query.length < 2) {
                return [];
            }
            return DocumentsService.staffList({ query: query }).then(function (data) {
                return data.docs;
            });
        };

        $scope.attachmentRequired = function () {
            for (var i in $scope.documentTypes) {
                var filtered = $scope.documentTypes[i].filter(function (el) {
                    return el._id === $scope.type
                });
                if (filtered.length > 0) {
                    return filtered[0].attachmentRequired || false;
                }
            }
            return false;
        }
    }]);
